import { useSelector } from "react-redux";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";
import BizDevelopmentDashboardMobile from "../../../components/BizDevelopment/Dashboard/DashboardMobile/BizDevelopmentDashboardMobile";
import ComingSoon from "../../../components/ComingSoon/ComingSoon";

const BizDevelopmentDashboardMobileScreen = () => {
  let react_env = import.meta.env.VITE_ENV;
  const userData = useSelector(selectUserData);
  const hasBizDevelopmentDashboardPermission = CheckPermissions(
    userData?.data?.products?.paid_traffic,
    "performance_analysis",
    "view_Bizdev_dashboard",
  );

  return (
    <>
      {react_env !== "staging" && react_env !== "development" ? (
        <ComingSoon />
      ) : hasBizDevelopmentDashboardPermission ? (
        <BizDevelopmentDashboardMobile />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default BizDevelopmentDashboardMobileScreen;
